export default __webpack_public_path__ + "static/media/f378f25172f5fe9021ce0e8d49bc74ac.svg";